<template>
  <button type="button" class="flex w-full items-center space-x-4 text-left">
    <div class="flex w-[60px] shrink-0 flex-col items-center space-y-1">
      <span class="text-text-neutral-primary">
        {{ logData.request.method }}
      </span>
      <span
        class="rounded-lg border p-1 leading-none"
        :class="{
          'text-text-neutral-tertiary border-situational-dark':
            responseStatusType === 'PENDING',
          'text-text-positive-primary border-green-500':
            responseStatusType === 'SUCCESS',
          'text-text-warning-accent border-orange-500':
            responseStatusType === 'REDIRECT',
          'text-text-negative-primary border-red-500':
            responseStatusType === 'ERROR',
        }"
      >
        {{ responseStatus }}
      </span>
    </div>
    <p class="flex w-[calc(100%-80px)] flex-col space-y-1">
      <span class="text-text-neutral-tertiary truncate text-xs">
        {{ logUrl.origin }}
      </span>
      <span class="text-text-neutral-primary truncate">
        {{ logUrl.pathname }}{{ logUrl.search }}
      </span>
    </p>
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { inRange } from 'lodash-es';
  import type { NetworkLog } from '../../../entities/network-log';

  const props = defineProps<{
    logData: NetworkLog;
  }>();

  const responseStatus = computed(() => {
    const { status } = props.logData;

    if (status === 'DONE') {
      return props.logData.response.status;
    }

    return 'PENDING';
  });

  const responseStatusType = computed(() => {
    if (responseStatus.value === 'PENDING') {
      return 'PENDING';
    }

    if (inRange(responseStatus.value, 200, 300)) {
      return 'SUCCESS';
    }

    if (inRange(responseStatus.value, 300, 400)) {
      return 'REDIRECT';
    }

    return 'ERROR';
  });

  const logUrl = computed(() => new URL(props.logData.request.url));
</script>
